<template>
  <div class="flex flex-col bg-block shadow-primaryBlock rounded
                  p-8 lg:px-12 lg:pt-13 lg:pb-10">
    <div class="text-xl font-bold text-text leading-tight mb-11">{{ $t('navTitle') }}</div>
    <div v-for="(route,i) in routes" :key="i" class="flex items-center mb-8">
      <router-link :to="route.to" class="link" exact-active-class="link-active">
        <component :is="`icon-${route.icon}`" class="mr-4"/>
        {{ route.name }}
      </router-link>
    </div>
  </div>
</template>

<script>
import IconQuestionSquare from "@/components/icons/IconQuestionSquare";
import IconComment from "@/components/icons/IconComment";

export default {
  name: "TicketsNav",
  components: {IconComment, IconQuestionSquare},
  computed: {
    routes() {
      return [
        {to: {name: 'ticket-system'}, name: this.$t('ticketSystem'), icon: 'comment'},
        {to: {name: 'faq'}, name: this.$t('faq'), icon: 'question-square'},
      ]
    }
  },
  i18n: {
    messages: {
      en: {
        navTitle: 'Help',
        ticketSystem: 'Support',
        faq: 'FAQ',
      },
      ru: {
        navTitle: 'Помощь',
        ticketSystem: 'Служба поддержки',
        faq: 'Частые вопросы',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.link {
  @apply flex text-text-secondary text-sm;
  transition: all .2s;

  svg {
    @apply text-icon ;
    width: 1.6rem;
    height: 1.6rem;
    transition: all .2s;
  }

  &:hover, &.link-active {
    @apply text-red;

    svg {
      @apply text-red;
    }
  }
}
</style>